import './App.css';
import { Toaster } from 'react-hot-toast';
import Navigator from './Navigator';
import { SessionProvider } from './context/SessionContext';
import { ApiProvider } from './context/ApiContext';
import { useBusy } from './context/BusyContext';
import BusyIndicator from './components/BusyIndicator';

function App() {
  const { isBusy } = useBusy();
  return (
    <div className='main-container'>
      <Toaster />
      <ApiProvider>
        <SessionProvider>
          {isBusy && <BusyIndicator />}
          <Navigator />
        </SessionProvider>
      </ApiProvider>
    </div>
  );
}

export default App;
